import React, { useEffect } from 'react';
import { ComplexValue } from 'app/types-shared';
import { VisibleForFields } from 'app/components/visible-for-fields';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { endpoints } from '../endpoints';
import { LinkExcludeProps } from './types';
import { getDisabledOptions } from './get-disabled-options';
import { getValidationWithoutDuplicates } from './get-validation';
import styles from './link-exclude.scss';

export const LinkExclude = (props: LinkExcludeProps) => {

  const { externalUrlItem, originalExternalUrlItem, options, validation, readOnly, loadOptions, onChange } = props;

  useEffect(() => {
    loadOptions('excludableFields', endpoints.excludableFields, undefined);
  }, [externalUrlItem?.id]);

  const excludableFieldsOptions = (!!options && !!options.excludableFields && options.excludableFields.codes
    || []) as ComplexValue<number>[];

  const fetching = !!options && !!options.excludableFields && options.excludableFields.fetching;

  const disabledOptions = getDisabledOptions(originalExternalUrlItem, excludableFieldsOptions);

  const excludeValidation = !!validation && !!validation.exclude ? getValidationWithoutDuplicates(validation.exclude) : undefined;

  const invalidOptionIds = !!excludeValidation ? excludeValidation.messages.map(message =>
    !!message.parameters && isDefinedIncludingZero(message.parameters.id) ? message.parameters.id : undefined) : [];

  const invalidOptions = !!excludableFieldsOptions && [...disabledOptions, ...excludableFieldsOptions].filter(option =>
    invalidOptionIds.some(id => id === option.value));

  return <div className={styles.clearRows}>
    <div className={`control-label ${styles.linkExcludeLabel}`}>
      Visible for fields
    </div>
    <VisibleForFields
      onChange={onChange}
      options={excludableFieldsOptions}
      fetching={fetching}
      invalidOptions={invalidOptions}
      onEmptyOptions={<div className={`${styles.noOptionsFound} no-content`}>No options found</div>}
      readOnly={readOnly}
      valueItems={externalUrlItem && externalUrlItem.excludeFields}
      initialValueItems={disabledOptions}
      validation={excludeValidation}
      loadingText={'Loading...'}
    />
  </div>;
};
